export function mainPhotoSlider() {

    function slider() {
        let $current = $(".header .photo img.active");
        if ($current.length === 0) {
            $(".header .photo img:first-child").addClass("active");
        } else {
            let $next = $current.removeClass("active").next();
            if ($next.length === 0) {
                $(".header .photo img:first-child").addClass("active");
            } else {
                $next.addClass("active");
            }
        }
    }

    setInterval(slider, 5000);
}


// WEBPACK FOOTER //
// ./assets/js/modules/mainPhotoSlider.js